export default "__VITE_ASSET__3Gf1YfHf__"